import React from "react"
import { TextTag } from "../atoms"
import moment from "moment"
import { Link } from "react-router-dom"
import _ from "../utils/lodashUtils"
/* General philosophy:
- Copy is Keepurr speaking to the user
- Button or link is the user saying what they want to do or tell Keepur a command
e.g. "I'm not ready yet" or "Notify me"
*/

// LANDING PAGE
export const SIGNUP_TEXT = "Closer. Together." // NEED REVIEW
export const SUB_TAGLINE =
  "A dedicated, shared concierge for just the two of you."
export const HOW_IT_WORKS = "How it works"
export const INFO_SECTION1_HEADING = "Invite your partner"
export const INFO_SECTION1 =
  'Surprise your partner by inviting them to adopt your dedicated, digital "concierge for two".'
export const INFO_SECTION2_HEADING = "Bond over the little and big things"
export const OFFLINE = "Internet Disconnected"
export const INFO_SECTION2 =
  "Whether it is a fleeting moment when you both reminisce about the same thing or a passionate discussion about what to order for dinner, the two of you are creating new memories. Go bonding!"
export const INFO_SECTION3_HEADING = "Keep the spark aflame"
export const INFO_SECTION3 =
  "No time to put away your devices and hold hands? No problem. Your concierge can facilitate virtual, mindful connection between you two. Make each other count, not just what you do for each other. "
export const INFO_SECTION4_HEADING = "Why digiD8?"
export const INFO_SECTION4 =
  "The world is full of annoying distractions. It can be hard to spend time with the person you love most. That’s why we’ve created a unique shared concierge tailored to your relationship. With digiD8, you can turn tiny interactions into an excuse to bond. When you take the time to care, good things happen."

// REGISTER NEW USER
export const CREATE_ACCOUNT = "Create account"
export const ALREADY_REGISTERED = "Already have an account?"
export const INVALID_MOBILE = "Enter a valid mobile number"

// EMAIL SIGN-IN
export const EMAIL_PLACEHOLDER = "Email address"
export const PASSWORD_PLACEHOLDER = "Password"
export const CONFIRM_PASSWORD_PLACEHOLDER = "Confirm your password"
export const FORGET_PASSWORD_BUTTON = "Forgot password?"
export const LOGIN_BUTTON = "Log in"
export const FINISH_SIGNIN = "Finish signing up"
export const SIGN_IN_TO = "Log in"
export const SIGN_UP_TO = "Sign up"
export const DINE_M8_TEXT = "digiD8"
export const NO_ACCOUNT_LABEL = "Don't have an account?"
export const SIGN_UP_BUTTON = "Sign up"
export const OR = "or"
export const AND = " and "
export const CONTINUE_TEXT = "Continue"
export const CONTINUE_EMAIL = "Continue with email"
export const BROWSER_INFO_MSG = "By signing up, you agree to digiD8's "
export const TERMS = "Terms of Service"
export const PRIVACY_POLICY = "Privacy Policy"
export const PRIVACY_POLICY_LINK = "https://www.digid8.com/privacy-policy"
export const TERMS_LINK = "https://www.digid8.com/terms"
// FORGOT PASSWORD
export const EMAIL_SENT_TO_RESET_PASSWORD = `A link to reset your password has been sent to your email.\n
Didn't receive the email yet? Check your spam folder, or make sure you’ve entered the email address you registered with.`
export const FORGOT_PASSWORD_DISCLAIMER =
  "A link to reset your password will be sent to your registered email address"
export const PASSWORD_SET_SUCCESSFULLY = `New password has been set successfully! Login with the new password.`
export const EXPIRED_LINK = `The link to reset password has expired.\n`
export const LOGIN_LINK = "Log in"
export const PASSWORD_RESET_TITLE = "Reset password"
export const SEND_EMAIL_BUTTON = "Send email"
export const RESET_PASSWORD_BUTTON = "Reset password"
export const RESET_PASSWORD_FORM_LINK = "Reset Password Form"

// MOBILE VERIFICATION
export const PHONE_PLACEHOLDER = "Mobile number"
// ADD MOBILE DISCLAIMER
export const OTP_LABEL = "Enter the verification code"
export const OTP_SCREEN_MSG = "You’re almost there!"
export const OTP_RESEND_MSG = "Didn’t receive the code?"
export const RESEND_AGAIN = "Send again"
export const INVALID_FLAG_SELECTED = "Invalid number for selected country"
export const OTP_PHONE_LABEL = "Phone"

// MY PROFILE
export const ABOUT_YOU_TAB = "About you"
export const CONTACT_TAB = "Contact"
export const INTEGRATION = "Integrations"
// ABOUT YOU SECTION TEXT CONSTANTS
export const FIRST_NAME_PLACEHOLDER = "First name"
export const LAST_NAME_PLACEHOLDER = "Last name"
export const PREFERRED_NOUNS_LABEL = "Preferred pronouns"
export const ABOUT_YOU_FEMALE_LABEL = "She, Her, Hers"
export const ABOUT_YOU_MALE_LABEL = "He, Him, His"
export const ABOUT_YOU_MANY_LABEL = "They, Them, Theirs"
export const ABOUT_YOU_DATE_OF_BIRTH_LABEL = "Birthday"
export const ABOUT_YOU_SAVE_PREFERENCES_BUTTON = "Next"
export const ABOUT_YOU_DISPLAY_NAME_REQUIRED_ERROR = "First name is required"
export const ABOUT_YOU_DOB_REQUIRED_ERROR = "Birthday is required"
export const ABOUT_YOU_DOB_GREATER_THAN_18_YEARS_ERROR =
  "You must be at least 18 years old to use digiD8"
export const UPLOAD = "Upload"
export const CONTACT_YOU_EMAIL_LABEL = "Email address"
export const CONTACT_YOU_EMAIL_PLACEHOLDER = "Email address"
export const CONTACT_YOU_PHONE_LABEL = "Mobile number"
export const NOT_AN_IMAGE_ERROR = "You can only upload JPG/PNG file!"
export const IMAGE_UPLOAD_FAILED = "Upload Failed"

// INVITE PAGE
export const INVITE_LABEL = "Invite your favorite person"
export const NICKNAME_LABEL = "Nickname"
export const NICKNAME_PLACEHOLDER = "Partner's nickname"
export const INVITE_EMAIL_LABEL = "Email"
export const INVITE_MOBILE_LABEL = "Phone"
export const INVITE_EMAIL_TAB = "Invite by email"
export const INVITE_PHONE_TAB = "Invite by text"
export const PARTNER_INVITED_HEADING = (partnerName) => (
  <p>
    You are invited to join <span> {partnerName}! </span>
  </p>
)
export const PARTENR_INVITED_SUB_HEADING = (partnerName, username, gender) => (
  <p>
    <span>{partnerName}</span> ( {username} ) invited you to bond with {gender}.{" "}
  </p>
)
export const NICKNAME_REQUIRED = "Nickname is required"

// INVITE EMAIL PHONE
export const EMAIL = "Email"
export const INVITE_FOOTER_TEXT =
  "I'm brewing some ideas for you to go bonding with your most favorite person in the world. But first, let's invite them over to your private space here!"
export const INVITE_RESEND_BUTTON = "Resend invite"
export const CHANGE_PARTNER = "Change partner"
export const INVITE_BUTTON = (name) => `Invite ${name}`
export const INVITE_PHONE_LABEL = "Partner's phone number"
export const INVITE_SUCCESS = "Invitation sent!"
export const EMPTY_PHONE_NUMBER = "Invitee Phone is required"
export const EMPTY_EMAIL_ADDRESS = "Invitee Email address is required"
export const INVITEE_EMAIL_PLACEHOLDER = "Partner's email"

// COUPLING PAGE
export const CHECK_RESTAURANTS = "Check restaurants in your area"
export const INVITE_RESEND_BANNER = (name) => `${name} is not here yet.`
export const INVITE_RESEND_BANNER_SUB_HEADING = "Tell your partner to hurry up"
export const PARTNER_ACCEPTED_INVITE = (partnerName) =>
  `${partnerName} has joined you!`
export const COUPLING_TEXT = `Explore digiD8 while you wait for your partner!`

// Check restaurants page
export const ENTER_INFO =
  "Enter your address and your partner's address to check if you have common restaurants!"
export const CHECK_BUTTON = "Check for restaurants"

export const PARTNER_NOT_MATCHED = `You have not partnered with anyone yet.`
export const INVITE_LINK = (
  <p>
    Please invite your partner here <Link to="/dashboard">Invite</Link>
  </p>
)

// Partner invite modal
export const PARTNER_SIGN_UP_MODAL_TITLE = (username) =>
  `You are logged in as ${username}`
export const PARTNER_SIGN_UP_MODAL_CONTENT = (oldUsername, username) =>
  `Do you want to log out from ${oldUsername} and log in as ${username}?`
export const CONTINUE_AS_LOGGED_IN_USER = "No, continue"

// NUDGE
export const PARTNER_OFFLINE = (name, gender) =>
  `${name} is not online. I can nudge ${gender} to join you here!`
export const NUDGE_BUTTON = "Send a nudge"

// PLAN DINNER
export const PLAN_DINNER = "Bond over food"
export const MEET_CONCIERGE = "Meet your concierge"
export const BOND_OVER_MEMORIES = "Bond over memories"
export const ORDER_DELIVERED_BUTTON = "Order is delivered"
export const ORDER_INFORMATION_BANNER_USER = (order) =>
  `Your order number is #${order.user_order.order_id}, with merchant ${_.get(
    order.user_order,
    "merchant_details.merchant",
    ""
  )} was placed on ${moment(
    order.user_order.created_on,
    YEAR_MONTH_DATE_FORMAT
  ).format(DD_MMM_YYYY_FORMAT)}`
export const PARTNER_ORDER_NUMBER_BANNER = (order) =>
  `${_.get(order.partner_order, "user.first_name")}'s order number is  #${_.get(
    order,
    "partner_order.order_id",
    ""
  )}`
export const COMBINED_ORDER_INFORMATION = (
  partnerName,
  orderNum,
  merchantName,
  orderDate
) =>
  `Your's and ${partnerName}'s order number is #${orderNum}, with merchant ${merchantName} was placed on  ${moment(
    orderDate,
    YEAR_MONTH_DATE_FORMAT
  ).format(DD_MMM_YYYY_FORMAT)}`

export const ORDER_INFORMATION_BANNER_SUB_HEADING = (name = "You") =>
  `${name} will be receiving a confirmation email with your order details.`
export const SUBMIT_BUTTON = "Submit"
export const RATE_YOUR_EXPERIENCE = "Rate your food"
export const RESTAURANT_UNAVAILABLE = "Currently unavailable"

// GET ADDRESS AND WAITING SCREEN
export const GET_ADDRESS_WAITING_SCREEN_TITLE = "Check restaurants delivery"
export const BACK_TO_PLAN_A_DATE_SCREEN_USER =
  "Are you sure you want to go back?"
export const BACK_TO_PLAN_A_DATE_SCREEN_PARTNER = (partnerName) =>
  `${partnerName} has moved back to plan`
export const EMPTY_RESTAURANTS_HEADER = "Restaurants List"
export const EMPTY_RESTAURANTS_MESSAGE =
  "Enter your delivery addresses to see restaurants show up here!"
export const OPEN_RESTAURANTS_HEADER_WITH_USER_ADDRESS = (count) =>
  `There are ${count} restaurants that deliver to you`
export const OPEN_RESTAURANTS_MESSAGE_WITH_USER_ADDRESS = (
  partnerName,
  gender
) =>
  `Check them out while you are waiting for ${partnerName} to enter ${gender} address!`
export const OPEN_RESTAURANTS_HEADER_WITH_PARTNER_ADDRESS = (
  count,
  partnerName
) => `There are ${count} restaurants that deliver to ${partnerName}`
export const OPEN_RESTAURANTS_MESSAGE_WITH_PARTNER_ADDRESS = "Check them out!"
export const CLOSED_RESTAURANTS_HEADER_WITH_USER_ADDRESS = (count) =>
  `There are ${count} restaurants that deliver to you but they are currently closed`
export const CLOSED_RESTAURANTS_MESSAGE_WITH_USER_ADDRESS = (
  partnerName,
  partnerGender,
  personGenderObjectiveMessage
) =>
  `Try changing your address to ${partnerName}’s. ${partnerGender} might have open restaurants nearby and you could order food together to ${personGenderObjectiveMessage} instead!`
export const CLOSED_RESTAURANTS_HEADER_WITH_PARTNER_ADDRESS = (
  count,
  partnerName
) =>
  `There are ${count} restaurants deliver to ${partnerName} but they are currently closed`
export const CLOSED_RESTAURANTS_MESSAGE_WITH_PARTNER_ADDRESS = (
  partnerName,
  partnerGender
) =>
  `Ask ${partnerName} to change ${partnerGender} address to yours so you can combine order. You might have open restaurants nearby and you could order food together to you instead!`
export const NO_RESTAURANTS_HEADER_WITH_USER_ADDRESS =
  "There are no restaurants that deliver to you"
export const NO_RESTAURANTS_MESSAGE_WITH_USER_ADDRESS = (
  partnerName,
  partnerGenderSubjectiveMessage,
  personGenderObjectiveMessage
) =>
  `Try changing your address to ${partnerName}’s. ${partnerGenderSubjectiveMessage} might have open restaurants nearby and you could order food together to ${personGenderObjectiveMessage} instead!`
export const NO_RESTAURANTS_HEADER_WITH_PARTNER_ADDRESS = (partnerName) =>
  `There are no restaurants that deliver to ${partnerName}`
export const NO_RESTAURANTS_MESSAGE_WITH_PARTNER_ADDRESS = (
  partnerName,
  partnerGenderSubjectiveMessage
) =>
  `Ask ${partnerName} to change ${partnerGenderSubjectiveMessage} address to yours so you can combine order. You might have open restaurants nearby and you could order food together to you instead! `
export const INVALID_ADDRESS = "Address cannot be empty."
export const VALIDATING_ADDRESS = "Validating Address..."
export const USE_PARTNER_ADDRESS = (partnerName) =>
  `We are in same location, use ${partnerName}'s address`
export const USING_PARTNER_ADDRESS = (partnerName) =>
  `Using ${partnerName}'s address`
export const USING_YOUR_ADDRESS = "Using your address"
export const SEARCH_ADDRESS_LABEL = "Your address"
export const SEARCH_PARTNER_ADDRESS_LABEL = "Partner's address"
export const PARTNER_ADDRESS_SEARCH_PLACEHOLDER = (partnerName) =>
  `${partnerName}'s delivery address`

// GET ADDRESS
export const NOT_SUPPORTED_FEEDBACK =
  "Geolocation is not supported by this browser."
export const ADDRESS_LABEL =
  "Enter your address so I can find restaurants nearby for you!"
export const COMBINE_ORDER = (partnerName) => `Heyya roomies!`
export const COMBINE_ORDER_INFO =
  "I recommend that you save up on those delivery fees. Shall I combine your food orders for a single delivery?"
export const YES_BUTTON = "Sure, combine orders"
export const NO_BUTTON = "No, don't bother"
export const ENABLE_LOCATION_BUTTON = "Use current location"
export const SAVE_BUTTON = "Save"
export const ADDRESS_PLACEHOLDER = "Address"
export const DELIVERY_ADDRESS_PLACEHOLDER = "Enter delivery address"

// RESTAURANT PAGE HEADING
export const RESTAURANT_SELECT_LABEL = "First challenge: agree on where to eat!"

// NO RESTAURANTS
export const RESTAURANT_NAME_PLACEHOLDER = "Enter restaurant name"
export const NO_RESTAURANT =
  "You gotta be kitten me! There are no restaurants that deliver to both of you."
export const THANK_YOU = "Thanks for letting me know!"
export const SUGGESTION_SAVED = "Your recommendation was saved."
export const RESTAURANT_SEARCH =
  "What is a restaurant you would like to see on digiD8?"

// NO OPEN RESTAURANTS
export const NO_RESTAURANT_OPEN = (count) => `You gotta be kitten me! There ${
  count > 1 ? "are" : "is"
} ${count} ${
  count > 1 ? "restaurants" : "restaurant"
} that deliver to both of you
but ${count > 1 ? "they are" : "it is"} currently closed.`
export const TRY_CHANGING_YOUR_LOCATION = (partnerName) =>
  `Hold on, I have some ideas. Change your address to ${partnerName}'s. You can still choose food together, but for one of you at a time. Double the bonding 😉`
export const NOTIFY_OPEN = "Notify us when they are open"

// CHOOSE RESTAURANT
export const LOADING = "Loading..."
export const RESTAURANT_COUNT = (count) =>
  `There ${count > 1 ? "are" : "is"} ${count} ${
    count > 1 ? "restaurants" : "restaurant"
  } that deliver to both of you.`
export const PARTNER_ADDRESS_PENDING = (name, gender) =>
  `Waiting for ${name} to put in ${gender} address` // remove after #362 is complete(combine address page)
export const PARTNER_UPDATED_ADDRESS_HEADING = (name, gender) =>
  `${name} teleported and changed ${gender} address`
export const PARTNER_UPDATED_ADDRESS_CONTENT =
  "Don't be surprised if you have new restaurants to choose from!"
export const ACCEPT_BUTTON = "Accept"
export const DECLINE_BUTTON = "Decline"
export const SUGGEST_BUTTON = "Suggest"
export const PROMOTION = "Promotion"
export const SEARCHBAR_PLACEHOLDER = "Type to find a specific restaurant"
export const CHANGE_ADDRESS_CONTENT = (name) =>
  `I hereby grant you the power to teleport yourself. Don't be surprised if you have new restaurants to choose from!`
export const YOUR_ADDRESS_LABEL = "Your address:"
export const YOUR_PARTNER_ADDRESS_LABEL = "Your partner's address:"
export const COMBINED_ORDER_LABEL = "Combined order"
export const COMBINED_ORDER_TOOLTIP =
  "This will combine your orders, saves the delivery fee and treats as one single order."

// RESTAURANT SELECT
export const RESTAURANT_ACCEPTED_TITLE = (partnerName) =>
  `You scored, ${partnerName} just accepted your suggestion!`
export const RESTAURANT_ACCEPTED_CONTENT = `You did great for your first challenge 🎉`
export const NO_RATING = "No ratings"
export const SUGGESTION_REJECTED = (partnerName) =>
  `${partnerName} declined your suggestion. Stay strong. Fake a smile and make another suggestion!`
export const SELECT_MENU = "Select menu"
export const TAKE_ME_TO_MENU = "Take me to the menu"
export const YOUR_SUGGESTION = (restaurant) => (
  <TextTag>
    You suggested <span>{restaurant}</span>
  </TextTag>
)
export const ETA = (time) => `Estimated time: ${time} min`
export const EXPLORE_MENU = "See menu"
export const CLOSED = "Closed"
export const REJECT_BUTTON = "Reject"
export const NOTIFY_WHEN_RESTAURANTS_OPEN =
  "I will let you know as soon as restaurants near you are open"
export const ESTTIME = (eta) => `Est time: ${eta}`

// MENUS
export const MENU_SUGGESTION_ACCEPTED = `Score! Suggestion accepted.`
export const MENU_SUGGESTION_DECLINED = `Miss! Suggestion flopped.`
export const DATE_ICON_SUFFIX = "What are you craving?"
export const CHOOSE_REQUIRED = (qty = 1) => `(Required - Choose ${qty})`
export const CHOOSE_OPTIONAL = "(Optional - Choose as many as you want)"
export const CHOOSE_MAX = (qty) => `(Optional - Choose upto ${qty})`
export const CLOSE_BUTTON = "Close"
export const ADD_ITEM_BUTTON = "Add to my plate"
export const UPDATE_ITEM_BUTTON = "Update my plate"
export const TAKE_ME_BACK = "Yes, go back"
export const CANCEL = "No, scratch that"

//GET READY PAGE
export const GET_READY_DINNER = "Tricks to keep you meowing along"
export const ORDER_TOGETHER = "A glimpse of what you're about to experience"
export const NEXT_BUTTON = "Next"
export const NEXT_MODAL_TEXT = (chatSpacename) =>
  `You will be able to see this again in "Meet ${chatSpacename}" page`
export const NEXT_INFO = (chatSpacename, partnerName) =>
  `Hello, it's ${chatSpacename} here! I'm supurr excited that you and ${partnerName} found the time to bond today. Let me show you around!`

// CART POPUP
export const SUGGESTED_YOU = "thought you would love these!"
export const YOUR_ORDER = "You"
export const PARTNER_ORDERS = (partnerName) => `${partnerName}`
export const ADD_TO_MY_CART = "I want this"
export const SUGGEST_ITEM = "Suggest"
export const ACCEPT_SUGGESTION = "Accept"
export const REJECTED_STATUS = "Rejected"
export const ACCEPTED_STATUS = "Accepted"
export const PENDING_STATUS = "Pending"
export const EMPTY_CART_TEXT = "I spy an empty plate!"
export const CHECKOUT_TEXT = "I'm done choosing food"
export const READY_STATUS = "Ready"
export const PARTNER_SUGGESTION = (partnerName) =>
  `You thought ${partnerName} would love these!`
export const DELIVERY_MINIMUM = (value) => `Delivery minimum: $${value}`
export const PARTNER_READY_FOR_CHECKOUT = (partnerName) =>
  `Me-wow. ${partnerName} is also done choosing food. Plate meets wallet time!`
export const NOT_READY_FOR_CHECKOUT = "I'm not ready yet, go back"
export const READY_TO_CHECKOUT = "I'm Ready to check out!"
export const UNDO = "Undo"
export const ADDED = "Added"
export const READY_FOR_CHECKOUT = (partnerName) =>
  `${partnerName} is done choosing food`
export const PARTNER_SUGGESTED_YOU = (partnerName) =>
  `${partnerName} has a very food idea for you!`
export const YOU_SUGGESTED_MENU = "You suggested a dish!"
export const SAME_ADDRESS_ORDER_DETAILS =
  "Includes tax, delivery fee and Partner's order"
export const ORDER_DETAILS = "Includes tax and delivery fee"
export const WAITING_TO_CHECKOUT = (name, gender) =>
  `I think ${name} needs more time to decide. Chat ${gender} up!`
export const POWERED_BY = "Powered by"
export const UPDATE_ORDER = "Update my plate"
export const SPECIAL_INSTRUCTIONS =
  "Is there anything I can tell the chef to customize for you?"
export const INSTRUCTIONS_PLACEHOLDER = "Enter any additional instructions here"
export const GO_TO_CHECKOUT = "Go to checkout"
export const YOUR_TOTAL = "Your total"
export const YOUR_PLATES = "Your plates"
export const PARTNER_TOTAL = (partnerName) => `${partnerName}'s total`

// CHECKOUT
export const RESTAURANT_CHECKOUT_LABEL = "Let's see if I got your plates right" // heading
export const PRICE = (price) => `$ ${price}`
export const DELIVERY_FEE = "Delivery fee"
export const SERVICE_FEE = "Service fee"
export const TAX = "Tax"
export const SUBTOTAL = "Subtotal"
export const DISCOUNT = "Discount"
export const TOTAL = "Total"
export const PAY_SELF = (total) => `Pay for myself $${total}`
export const PAY_BOTH = (total) => `Pick up the tab $${total}`
export const RESTAURANT = "Restaurant"

// Billing
export const SELF = "self"
export const BOTH = "both"
// pick up tab for modal
export const OFFERED_PAY_BOTH = (name, gender) =>
  `Cha-ching! ${name} is picking up the tab. Show ${gender} some love 😻!`
export const PAYING_FOR = (name, gender) =>
  `Apparently we are going Dutch today`

// CONFIRM ORDER DETAILS
export const YOU_PAY_BOTH = "Chivalry is not dead! Who me-ow?"
export const PARTNER_PAY_BOTH = (name, gender) =>
  `${name} is picking up the tab 😻!` //heading on partner page
export const YOU_PAY_SELF = "Apparently we're going Dutch today" //heading common to both on pay for self
export const CHANGE_ADDRESS_TITLE = "Your delivery address"
export const CHANGE_ADDRESS_WARNING =
  "Teleportation is dangerous. You might not be able to get your food delivered."
export const CONFIRM_DETAILS = "Contact details"
export const FIRST_NAME = "First name"
export const LAST_NAME = "Last name"
export const USER_ADDRESS = (address) => `Address: ${address}`
export const EDIT_BUTTON = "Edit"
export const ORDER_LABEL = "Order details "
export const ORDER_TOTAL = (myTotal) => `Total: $${myTotal}`
export const DELIVERY_TOTAL = (value) => `Delivery fee: $${value}`
export const DISCOUNT_TOTAL = (value) => `Discount: $${value}`
export const TIP = "Show your support with a tip : "
export const AMOUNT = "Amount"
export const TAX_TOTAL = (value) => `Tax: $${value}`
export const CONFIRM_BUTTON = "Confirm"
export const YOUR = "Your"

// WAITING FOR PARTNER
export const WAITING_FOR_PARTNER_TO_COMPLETE = (partnerName) =>
  `${partnerName} should be done any minute now`
export const WAITING_TO_CONFIRM_ORDER = (name, gender) =>
  `${name} is confirming ${gender} details and should be done any minute now`
export const WAITING_FOR_PARTNER_TO_PAY = (name) => (
  <TextTag>
    {name} is paying up. You can wait here or come{" "}
    <Link to="/meet-concierge">
      <TextTag textType="linkText">
        <span style={{ fontSize: "16px" }}>chat with me!</span>
      </TextTag>
    </Link>
  </TextTag>
)
export const WAITING_FOR_PAYMENT_PAGE =
  "Please wait while we go to payment page."

// PAYMENT
export const TIP_10 = "10%"
export const TIP_15 = "15%"
export const TIP_20 = "20%"
export const TIP_CASH = "Tip cash"
export const TIP_CUSTOM = "Custom"
export const PLUS_BUTTON = "+"
export const MINUS_BUTTON = "-"
export const PAYMENT_METHOD = "Payment method"
export const PAYMENT_FAIL_FEEDBACK =
  "There was a problem with your payment. Try again!"
export const CARD_DETAILS = "Card details"
export const PLACE_ORDER_BUTTON = (finalAmount) =>
  `Place order : $${finalAmount}`
export const CREDIT_EXPIRE_PLACEHOLDER = "MM/YY Expiry date"
export const CARD_NUMBER_PLACEHOLDER = "Enter card number"
export const CARD_CVV_PLACEHOLDER = "Enter CVV"
export const CARD_BILLING_ZIP_PLACEHOLDER = "Enter billing zip"
export const SAVE_FUTURE_TEXT = "Save details for future order"
export const PHONE_REQUIRED_PLACEHOLDER = "Phone Number"
export const CARD_NUMBER_REQUIRED_VALIDATION = "Card number cannot be blank"
export const MIN_CARD_LENGTH = "Card number should be minimum 14 digits"
export const MAX_CARD_LENGTH = "Card number should be maximum 16 digits"
export const CARD_NUMBER_VALIDATION = "Not a valid Credit Card number"
export const CVV_REQUIRED_VALIDATION = "Invalid CVV"
export const CVV_VALIDATION = "Not a Valid CVV"
export const EXPIRY_DATE_REQUIRED = "Expiry date is required"
export const EXPIRY_DATE_VALIDATION = "Not a Valid Date"
export const BILLING_ZIP_REQUIRED = "ZIP code is required"
export const BILLING_ZIP_MIN_MAX = "Enter valid zip cdode"
export const FIRST_NAME_REQUIRED = "First name cannot be blank"
export const LAST_NAME_REQUIRED = "Last name cannot be blank"
export const EMAIL_REQUIRED = "Email address cannot be blank"
export const PHONE_NUMBER_REQUIRED = "Phone number cannot be blank"
export const PHONE_NUMBER_VALIDATION = "Enter A Valid Mobile Number"
export const INVALID_EXPIRY_DATE = "Invalid date"
export const SERVICE_CHARGE = "Service fee"

// ORDER CONFIRMATION PAGE
export const ORDER_PLACED = "Order placed!"
export const YOUR_ORDER_MESSAGE = (orderNumber) =>
  `Your order number is: ${orderNumber}`
export const PARTNER_ORDER_MESSAGE = (partnerName, orderNumber) =>
  `${partnerName} order number is : ${orderNumber}`
export const COMBINED_ORDER_MESSAGE = (orderNumber) =>
  `Your combined order number is: ${orderNumber}`
export const PARTNER_COMPLETE_ORDER = (partnerName) =>
  `${partnerName} has completed order!`
export const NOT_CHARGED = "You will not be charged yet"

// SUGGESTION GENERATE SILLY NAME TEXT CONSTANTS
export const SPACE_MODAL_TITLE = "What do you want to call me?"
export const SUGGEST_NAME = "Surprise me"
export const GENERATE_OR_CHOOSE = (name) => `Current: ${name}`
export const CHAT_SPACE_PLACEHOLDER = "Coin a name"
export const DEFAULT_SPACE_NAME = "Keepurr"

// CHAT
export const CHAT_WINDOW_PLACEHOLDER = "Write something"
export const EDIT_ADDRESS = "Edit address"

// PARTNER AWAY
export const PARTNER_AWAY = (name) => `${name} is away`
export const CALL_PARTNER_BACK = (gender) =>
  `It takes two to bond-o. To unlock all your bonding options you'll need your partner-in-crime.`
export const NOTIFY_BUTTON = (gender) => `Ask ${gender} to come back`

// NOTIFY BACK
export const NOTIFY_BACK = (partnerName) =>
  `You are missing out on the action. Let me take you back to ${partnerName}.`
export const NOTIFY_BACK_BUTTON = (partnerName) => `Take me to ${partnerName}`

// tooltips
export const PENDING = "Pending"
export const REJECTED = "Rejected"
export const ACCEPTED = "Accepted"
export const ORDERED = (name) => `${name} ordered this`
export const SUGGEST_TO = "Suggest to partner"
export const SUGGESTED_THIS = (name) => `${name} suggested this`
export const ADD_TO_MINE = "Add to my order"
export const BACK_BUTTON = "Back"
export const CHANGE_EMAIL_BUTTON = "Change Email"

// Different Back buttons
export const BACK_FROM_MEAL = "Back"
export const BACK_FROM_CHECKOUT = "Back"
export const BACK_FROM_CHECKOUT_DETAIL = "Back"
export const BACK_FROM_CHECKOUT_WAITING = "Back"
export const BACK_FROM_PAYMENT = "Back"
export const BACK_FROM_CHECK_RESTAURANT = "Back"

// DEFAULT KEEPURR PIC
export const GET_CAT_IMAGE = (name) => `https://robohash.org/${name}?set=set4`
// DEFAULT PROFILE PIC
export const GET_ROBO_IMAGE = (name) =>
  `https://api.adorable.io/avatars/300/${name}`

// AVATAR DROP-DOWN TEXT CONSTANTS
export const PARTNER_LABEL = "My partner"
export const INTEGRATION_LABEL = "Connected apps"
export const PROFILE_LABEL = "My profile"
export const LOGOUT_BUTTON = "Log out"
export const HELP_LABEL = "Help"
export const placeHolder_Help = "Write your request here"
export const JOURNAL_LABEL = (chatSpacename) => `Meet ${chatSpacename}`

// INTEGRATIONS PAGE
export const WHATS_THIS = "What's this?"
export const ALLOW_INTEGRATION_BUTTON = "Allow"
export const NOT_NOW_INTEGRATION_BUTTON = "Not now"
// INTEGRATION PAGE
export const SETUP_INTEGRATION = "Set up connected apps"
export const SKIP_NOW = "Skip"

// MY PARTNER PAGE
export const EMAIL_LABEL = "Email: "
export const PHONE_LABEL = "Phone: "
export const SPACE_NAME_LABEL = "Assistant name: "
export const REMOVE_PARTNER_TITLE = "Remove partner"
export const CONFIRMATION_CONTENT =
  "Are you sure you want to remove the partner?" // change
export const PARTNER_REMOVED = (name) =>
  `${name} has been removed as your partner.` // change
export const REMOVE_PARTNER_BUTTON = "Remove partner"
export const YES_REMOVE = "Yes, remove"

// HELP PAGE
// SHOULD WE BE KEEPURR OR HUMANS?
export const HELP_HEADING =
  "Let us know what you need help with. We'll get back to you as soon as we can!" //
export const HELP_SUCCESS = "We have received your submission." //

// Pop up content for back button

// Add a constant for continue button here
export const CONTINUE = (partnerName) => `Let's do what ${partnerName} says`

// From menu to restaurants
export const GO_BACK_FROM_MENU =
  "Fair warning: you sure you want to go back and find a different restaurant?"
export const WARNING_TO_CLEAR_CART = (name) =>
  `I will be clearing both of your plates.`
export const GO_BACK_FROM_MENU_PARTNER = (partnerName) =>
  `Looks like the hardest decision hasn't been settled yet! ${partnerName} would like to go back to choosing restaurant.`

// From order details to menu
export const PARTNER_GO_BACK_FROM_CHECKOUT = (
  name,
  genderPosessive,
  genderWant
) =>
  `Me-wow, ${name} cannot make up ${genderPosessive} mind. ${genderWant} to go back to choose food.`
export const GO_BACK_FROM_CHECKOUT = "You sure you want to go back to the menu?"
export const GO_BACK_CONTENT = (partnerName) =>
  `Me-wow, we have an indecisive one amongst us! I'll take you back, but I'll have to drag ${partnerName} back too.`

// From order confirmation to order details
export const PARTNER_GO_BACK_FROM_CHECKOUT_DETAIL = (
  name,
  genderPosessive,
  genderWant
) =>
  `Me-wow, ${name} cannot make up ${genderPosessive} mind. ${genderWant} to go back to plates summary.`
export const GO_BACK_FROM_CHECKOUT_DETAIL =
  "You sure you want to go back to review your plates?"

// From payment to order details
export const GO_BACK_FROM_CHECKOUT_WAITING =
  "You sure you want to go back to review your plates?"
export const PARTNER_GO_BACK_FROM_CHECKOUT_WAITING = (
  name,
  genderPosessive,
  genderWant
) =>
  `Me-wow, ${name} cannot make up ${genderPosessive} mind. ${genderWant} to go back to plates summary.`
export const GO_BACK_FROM_PAYMENT =
  "You sure you want to go back to review your plates?"

//From restaurants to plan-a-dinner
export const PARTNER_GO_BACK_FROM_RESTAURANTS = (
  name,
  genderPosessive,
  genderWant
) =>
  `Me-wow, ${name} cannot make up ${genderPosessive} mind. ${genderWant} to go back to planning a dinner.`
export const GO_BACK_FROM_RESTAURANTS =
  "You sure you want to go back to plan a dinner?"

// Interval time
export const INTERVAL_TIME = 5000

export const PRODUCT_NAME = "digiD8"

//embed instructions in get ready page
export const CUI_EMBED_URL =
  "https://public-assets.typeform.com/confab/embed.js"
// export const JOURNAL_POPUP_URL = uid => `https://digid8.typeform.com/to/${uid}`
export const JOURNAL_POPUP_URL = (uid) => `https://digid8.typeform.com/c/${uid}`

//Shared profile page
export const SHARED_PAGE_DESCRIPTION = (chatSpacename) =>
  `Hi, I am ${chatSpacename}, the keeper for your relationship :) `
export const WHAT_TO_DO = (partnerName) =>
  `What ${partnerName} and you can do with me:`
export const PERSONALIZE_CONCIERGE = "Personalize your concierge"
export const HEALTH_DECISION_TAG = "Ask me about a health decision"
export const JOURNAL_WITH_LABEL = (chatSpacename) =>
  ` Journal with ${chatSpacename}`
export const ANSWER_PLACEHOLDER = (partnerName) =>
  `${partnerName ? partnerName + "'s" : "Your"} answer`
export const DATE_PLACEHOLDER = "Select a date"
export const SAVED_MESSAGE = "Answer saved!"
export const MESSAGE_TIMEOUT = 3000
export const DATE_MONTH_YEAR_FORMAT = "Do-MMM-YYYY"
export const YEAR_MONTH_DATE_FORMAT = "YYYY-MM-DD"
export const DD_MMM_YYYY_FORMAT = "DD-MMM-YYYY"
//questions
export const QUESTIONS = [
  "What is a date that means something to you?. Why?",
  "What was the very first thing you thought when you saw your partner",
  "What is your superpower as a couple?",
  "What is the most comforting thing your partner has ever said to you?",
  "What song reminds you of your partner?",
  "Describe something your partner would never have done without you.",
]
